// Centralized API config for prod/local
export const API_BASE_URL = process.env.REACT_APP_API_URL || process.env.VITE_API_URL || 'https://diaperstops-backend.fly.dev';

export async function login(email: string, password: string) {
  const res = await fetch(`${API_BASE_URL}/api/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Login failed');
  return res.json();
}

export async function register(email: string, password: string, fullName?: string, phoneNumber?: string) {
  const res = await fetch(`${API_BASE_URL}/api/auth/signup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name: fullName || email.split('@')[0], email, password })
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Registration failed');
  return res.json();
}

// No forgot password endpoint yet
export async function forgotPassword(email: string) {
  // Placeholder: show not implemented
  throw new Error('Forgot password is not implemented. Please contact support.');
}

// Fetch all locations
export async function getLocations(featured?: boolean) {
  let url = `${API_BASE_URL}/api/locations`;
  if (featured !== undefined) {
    url += `?featured=${featured}`;
  }
  const res = await fetch(url);
  if (!res.ok) throw new Error('Failed to fetch locations');
  return res.json();
}

// Fetch featured locations only
export async function getFeaturedLocations() {
  return getLocations(true);
}

// Fetch all stations
export async function getStations() {
  const res = await fetch(`${API_BASE_URL}/api/stations`);
  if (!res.ok) throw new Error('Failed to fetch stations');
  return res.json();
}
